// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"7b8d2743","335":"def4f23b"}[chunkId] + ".chunk.css";
};